import { TFunction } from "i18next"

export const ESTADOS_CUENTAS_BANCARIAS = {
  PENDIENTE: 0,
  REVISANDO: 1,
  VALIDADA: 2,
  RECHAZADA: 3,
}
export const ESTADOS_PROPERTIES = (t: TFunction) => {
  const status = {
    [ESTADOS_CUENTAS_BANCARIAS.PENDIENTE]: {
      className:
        "tw-text-center tw-text-warning tw-bg-warning-10 tw-px-6 tw-py-1 tw-rounded-md tw-font-medium",
      text: t("bancos.bankCard.unverified"),
    },
    [ESTADOS_CUENTAS_BANCARIAS.REVISANDO]: {
      className:
        "tw-text-center tw-text-info tw-bg-info-10 tw-px-6 tw-py-1 tw-rounded-md tw-font-medium",
      text: t("bancos.bankCard.reviewing"),
    },
    [ESTADOS_CUENTAS_BANCARIAS.VALIDADA]: {
      className:
        "tw-text-center tw-text-success tw-bg-success-10 tw-px-6 tw-py-1 tw-rounded-md tw-font-medium",
      text: t("bancos.bankCard.verified"),
    },
    [ESTADOS_CUENTAS_BANCARIAS.RECHAZADA]: {
      className:
        "tw-text-center tw-text-danger tw-bg-danger-10 tw-px-6 tw-py-1 tw-rounded-md tw-font-medium",
      text: t("bancos.bankCard.rejected"),
    },
    default: {
      className: "",
      text: "",
    },
  }
  return status
}
